import React, { Suspense } from 'react';
import { useTypedSelector } from '@hooks';
import { useAuth } from '@hooks/useAuth';
import { useDebounced } from '@helpers/useDebounced';

const BootcampModal = React.lazy(() => import('./BootcampModal'));

export default function BootcampModalContainer() {
  const { user } = useAuth();
  const modalState = useTypedSelector(({ modal }) => modal.bootcampModal);
  const visibleDebounced = useDebounced(modalState?.visible, 300, false);
  const visible = modalState?.visible || visibleDebounced;
  if (!modalState || !visible || !user) return null;

  return (
    <Suspense fallback={null}>
      <BootcampModal {...modalState} />
    </Suspense>
  );
}
